import { createElement } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import BootstrapButton from '../bootstrap/Button.js';
import { withKeyboardAccessibility } from '../Utilities/AccessibilityUtilities';

// This is to avoid bootstrap adding btn-md class
// to medium sized buttons
const sizeMap = {
  large: 'lg',
  medium: undefined,
  // Default size doesn't need a bsSize prop
  small: 'sm'
};
function Button(_ref) {
  let {
    className,
    circle = false,
    bsSize = 'medium',
    bsStyle = 'default',
    disabled = false,
    ...rest
  } = _ref;
  // `text` style creates an accessible span to embed in text
  // vs. `link` button which uses the specific `button.btn-link` styling
  // If your text button has `href`, you should be using `Link`, not `Button`
  if (bsStyle === 'text' || bsStyle === 'text-decorated' || bsStyle === 'text-decorated-inverse' || bsStyle === 'text-inverse') {
    const textClassName = clsx(className, 'text-link', {
      'display-block': rest.block,
      'link-undecorated': bsStyle === 'text' || bsStyle === 'text-inverse',
      inverted: bsStyle === 'text-decorated-inverse' || bsStyle === 'text-inverse'
    });

    // clean up props
    Object.keys(BootstrapButton.defaultProps).forEach(key => delete rest[key]);
    return /*#__PURE__*/createElement('span', {
      className: textClassName,
      tabIndex: 0,
      role: 'button',
      ...(typeof rest.onClick === 'function' && {
        onKeyDown: withKeyboardAccessibility(rest.onClick)
      }),
      ...rest
    });
  }

  // Use Bootstrap Buttons
  return /*#__PURE__*/createElement(BootstrapButton, {
    className: clsx(className, {
      'btn-circle': circle
    }),
    bsSize: sizeMap[bsSize],
    bsStyle,
    disabled,
    ...(typeof rest.onClick === 'function' && {
      onKeyDown: withKeyboardAccessibility(rest.onClick)
    }),
    ...(rest.href && typeof rest.onClick === 'function' && !rest.onContextMenu && {
      onContextMenu: rest.onClick
    }),
    ...rest
  });
}
export default Button;